import { __assign, __awaiter, __generator } from "tslib";
import { v4 as uuid4 } from "uuid";
import { act, render } from "@testing-library/react";
import { ServiceName } from "./shared/types";
export var createMockAccount = function (_a) {
    var _b = _a === void 0 ? {} : _a, overrides = _b.overrides;
    return __assign({ id: uuid4(), accessLevels: {
            accountAdmin: true,
            projectAdmin: true,
            projectMember: true,
            executive: false,
            noAccess: false,
            acsProjectAdmin: false,
        }, adminGroupId: "36205810", autoAssignSubscriptions: true, createCompanyAccessLevels: ["accountAdmin", "projectAdmin"], createProjectAccessLevels: ["accountAdmin", "projectAdmin"], endDate: "2045-12-31", hasAcsUnifiedProjects: true, hasBim360Projects: true, imageUrl: "sampleUrl", isAccEligible: true, isTrial: false, name: "Golden Gate 2", region: "US", services: [
            {
                displayName: "Project Administration",
                removable: false,
                serviceIcon: "sampleIconUrl",
                serviceName: ServiceName.ProjectAdministration,
            },
            {
                displayName: "Document Management",
                removable: false,
                serviceIcon: "sampleIconUrl",
                serviceName: ServiceName.DocumentManagement,
            },
        ], thumbnailImageUrl: "sampleUrl" }, overrides);
};
export var renderWithWait = function (toRender) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // https://github.com/floating-ui/react-popper/issues/350#issuecomment-691148800
                // https://autodesk.slack.com/archives/C02B5TNLFN3/p1643820967629369?thread_ts=1643804939.505629&cid=C02B5TNLFN3
                render(toRender);
                return [4 /*yield*/, act(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, null];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
